import { all, takeLatest } from 'redux-saga/effects'

import { settingApi } from '../../../services/'
import {
  getFrontendSettingRequest,
  updateFrontendSettingRequest
} from '../actions'
import { getFrontendSettingSaga } from './getFrontendSetting'
import { updateFrontendSettingSaga } from './updateFrontendSetting'

export function* settingSaga() {
  try {
    yield all([
      takeLatest(
        getFrontendSettingRequest as any,
        getFrontendSettingSaga,
        settingApi
      ),
      takeLatest(
        updateFrontendSettingRequest as any,
        updateFrontendSettingSaga,
        settingApi
      )
    ])
  } catch (err) {
    // TODO: handle error
  }
}
